/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import ImportFileModal from "@component/ImportFileModal";
import { ExclamationCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import { IntoWarehouseDetails, IWAppProductItem, ModifyStatus } from "@api/brandOperationApi";
import useDebounce from "@hooks/useDebounce";
import {
  IWBrandState,
  fetchIWAppProductList,
  fetchBrandVpc,
  clearBrandVpc,
  addIWapplicationProduct,
  editIWapplicationProduct,
  setImportFilePopup,
  importIWappsProductsXLS,
  deleteIWappsProducts,
  uploadWMSystem,
  clearCsvErrorReason,
  updateProductListParams,
  fetchVirtualMovement,
} from "@redux/brandOperation/intoWarehouseBrandSlice";
import { Button, Form, Modal, message, DatePicker, Input, Select, InputNumber, Row } from "antd";
import { FormInstance } from "antd/lib/form";
import { ColumnsType } from "antd/lib/table";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Header, FlexBox } from "src/styles/common";
import fontStyle from "src/styles/fontStyle";
import styled from "styled-components";
import moment from "moment";
import { storageTypeOptions } from "@constant/StorageType";
import { PurchaseStatus } from "@api/utils/normalizeWarehouse";
import PopupBackground from "@component/PopupBackground";
import IntegratedTable from "@component/Table/IntegratedTable";

const Remarks = styled.span<{ emphasize?: boolean }>`
  position: absolute;
  left: 32px;
  bottom: 20px;
  color: ${({ emphasize, theme }) => (emphasize ? "#EC6922" : theme.colorNeutral600)};
  ${fontStyle("14px", "16px")};
`;
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 364px;
  padding: 20px;
  background-color: white;
`;
const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 14px;
`;
const ButtonWrapper = styled(Row)`
  margin-top: 24px;
`;

type Props = {
  intoWarehouseDetails: IntoWarehouseDetails;
};

const ProductTab = (props: Props) => {
  const { intoWarehouseDetails } = props;
  const { status, stoNumber, virtualOrder } = intoWarehouseDetails;
  const canDeploy = !intoWarehouseDetails.stoNumber;
  const showVirtualBtn = stoNumber.startsWith("TAV");

  const dispatch = useDispatch();
  const { isFetching, productList, showImportFilePopup, csvErrorReason, productListParams } = useSelector(IWBrandState);
  const [showAddModel, setShowAddModel] = useState(false);
  const [showVirtualPopup, setShowVirtualPopup] = useState(false);
  const [editRecord, setEditRecord] = useState<IWAppProductItem | undefined>();
  const [platform, setPlatform] = useState<string>("實體-PW健身工廠");

  const { id: strAppId } = useParams();
  const applicationId = Number(strAppId);
  const [modal] = Modal.useModal();
  const [form] = Form.useForm();

  const columns: ColumnsType<any> = [
    {
      key: "no",
      dataIndex: "no",
      title: "SKU(品號)",
      width: 100,
    },
    {
      key: "sku",
      dataIndex: "sku",
      title: "Barcode",
      width: "10%",
    },
    {
      key: "name",
      dataIndex: "name",
      title: "商品名稱",
    },
    {
      key: "storageType",
      dataIndex: "storageType",
      title: "倉別",
      align: "center",
      width: 140,
      render: (value) => storageTypeOptions.find((option) => option.key === value)?.name,
    },
    {
      key: "batch",
      dataIndex: "batch",
      title: "批號",
      align: "center",
      width: 80,
    },
    {
      key: "purchasePrice",
      dataIndex: "purchasePrice",
      title: "進價",
      align: "center",
      width: 80,
    },
    {
      key: "requestQty",
      dataIndex: "requestQty",
      title: "申請進貨數量(件)",
      width: 140,
      align: "center",
    },
    {
      key: "arrivedQty",
      dataIndex: "arrivedQty",
      title: "實際進貨總量(件)",
      width: 140,
      align: "center",
    },
    {
      key: "expiredDate",
      dataIndex: "expiredDate",
      title: "有效期限",
      align: "center",
      width: 120,
    },
    {
      key: "stockinDate",
      dataIndex: "stockinDate",
      title: "上架時間",
      align: "center",
      width: 120,
    },
    // {
    //   key: "",
    //   dataIndex: "",
    //   render: (_, record) => (
    //     <FlexBox>
    //       <Button
    //         type="link"
    //         onClick={() => {
    //           setEditRecord(record);
    //           setShowAddModel(true);
    //         }}
    //         disabled={!canDeploy}
    //       >
    //         編輯
    //       </Button>
    //       <Button
    //         type="link"
    //         onClick={() => onDeleteProduct(record)}
    //         disabled={record.modifyStatus === ModifyStatus.LIMIT || record.modifyStatus === ModifyStatus.NONE}
    //       >
    //         刪除
    //       </Button>
    //     </FlexBox>
    //   ),
    // },
  ];

  const onDeleteProduct = (values: IWAppProductItem) => {
    Modal.confirm({
      title: "你確定要刪除這筆資料？",
      content: `商品品號: ${values.no}`,
      icon: <ExclamationCircleOutlined />,
      okText: "是",
      cancelText: "否",
      onOk() {
        dispatch(deleteIWappsProducts({ applicationId, productId: values.id }));
      },
    });
  };

  const handleAddProduct = () => {
    const values = form.getFieldsValue();
    if (editRecord) {
      dispatch(
        editIWapplicationProduct({
          id: editRecord.id,
          applicationId,
          ...values,
          name: undefined,
          expiredDate: values.expiredDate?.format("YYYY-MM-DD") || "",
        }),
      );
      setEditRecord(undefined);
    } else {
      dispatch(
        addIWapplicationProduct({
          applicationId,
          ...values,
          name: undefined,
          expiredDate: values.expiredDate?.format("YYYY-MM-DD") || "",
        }),
      );
    }
    form.resetFields();
    setShowAddModel(false);
  };
  const handleAddModalClose = () => {
    setShowAddModel(false);
    setEditRecord(undefined);
  };
  const handelAddXLS = (file: File) => {
    dispatch(importIWappsProductsXLS({ applicationId, file }));
  };
  const handelUploadWMS = () => {
    if (productList.count === 0) {
      message.error("請先新增商品");
      return;
    }
    dispatch(uploadWMSystem(applicationId));
  };

  useEffect(() => {
    const payload = { applicationId, ...productListParams };
    dispatch(fetchIWAppProductList(payload));
  }, [applicationId, dispatch, productListParams]);

  useEffect(() => {
    if (csvErrorReason.statusCode === 5007) {
      const content = () => {
        const result = Object.entries(csvErrorReason?.result);
        return (
          <>
            {result.map((r) => (
              <div key={r[0]}>{`${r[1]}`}</div>
            ))}
          </>
        );
      };
      Modal.error({
        title: "匯入失敗",
        content: <>{content()}</>,
        onOk: () => {
          dispatch(clearCsvErrorReason());
          dispatch(setImportFilePopup(false));
        },
        okText: "確認",
      });
    }
  }, [csvErrorReason, dispatch, modal]);

  return (
    <>
      <Header>
        <FlexBox>
          {/* <Button
            type="primary"
            icon={<PlusCircleFilled />}
            onClick={() => setShowAddModel(true)}
            disabled={!canDeploy}
          >
            新增商品
          </Button>
          <Button onClick={() => dispatch(setImportFilePopup(true))} disabled={!canDeploy}>
            匯入商品
          </Button> */}
          <Button onClick={handelUploadWMS} disabled={status !== PurchaseStatus.NORMAL}>
            上傳至WMS系統
          </Button>
          {showVirtualBtn && (
            <Button disabled={virtualOrder !== null} onClick={() => setShowVirtualPopup(true)}>
              虛入虛出
            </Button>
          )}
        </FlexBox>
      </Header>
      <IntegratedTable
        isPagination
        paginationConfig={{
          totalCount: productList.count,
          updateFilterParams: (filter) => dispatch(updateProductListParams(filter)),
          filterParams: productListParams,
        }}
        loading={isFetching}
        scroll={{ x: "max-content", y: 500 }}
        columns={columns}
        dataSource={productList.results}
        rowKey="id"
      />
      <AddAndEditModal
        form={form}
        open={showAddModel}
        onClose={handleAddModalClose}
        editRecord={editRecord}
        onSubmit={handleAddProduct}
      />
      {showVirtualPopup && (
        <PopupBackground close={() => setShowVirtualPopup(false)}>
          <InnerWrapper>
            <Title>請選擇虛出通路</Title>
            <Select defaultValue="實體-PW健身工廠" onChange={(value) => setPlatform(value)}>
              <Select.Option value="實體-PW健身工廠">實體-PW健身工廠</Select.Option>
              <Select.Option value="實體-PX健身工廠">實體-PX健身工廠</Select.Option>
              <Select.Option value="實體-迪卡儂">實體-迪卡儂</Select.Option>
              <Select.Option value="50" disabled>
                饌元辦公室
              </Select.Option>
            </Select>
            <ButtonWrapper justify="end">
              <Button style={{ marginRight: "10px" }} onClick={() => setShowVirtualPopup(false)}>
                取消
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  dispatch(fetchVirtualMovement({ applicationId, platform }));
                  setShowVirtualPopup(false);
                }}
              >
                確認
              </Button>
            </ButtonWrapper>
          </InnerWrapper>
        </PopupBackground>
      )}
      {showImportFilePopup && (
        <ImportFileModal
          csvErrorMessage=""
          closePopup={() => dispatch(setImportFilePopup(false))}
          clearErrorMessage={() => {}}
          handleUploadFile={handelAddXLS}
          templatePath="admin/template/xls/intoWarehouse_products_template.xlsx"
          fileType=".xlsx"
        />
      )}
    </>
  );
};

export default ProductTab;

type AddModalProps = {
  onSubmit: () => void;
  onClose: () => void;
  open: boolean;
  form: FormInstance;
  editRecord?: IWAppProductItem;
};

const AddAndEditModal = (props: AddModalProps) => {
  const { onSubmit, onClose, open, form, editRecord } = props;
  const dispatch = useDispatch();
  const { isFetching, brandVpcIsContract, brandVpc } = useSelector(IWBrandState);
  const { id: strAppId } = useParams();
  const applicationId = Number(strAppId);

  const cantEdit = useMemo(
    () => editRecord?.modifyStatus === ModifyStatus.LIMIT || editRecord?.modifyStatus === ModifyStatus.NONE,
    [editRecord?.modifyStatus],
  );
  const handleOnSubmit = () => {
    if (!brandVpcIsContract) {
      message.error("請輸入有效商品品號");
      return;
    }
    onSubmit();
  };
  const handleCancel = () => {
    onClose();
    dispatch(clearBrandVpc());
    form.resetFields();
  };
  const remark = useMemo(() => {
    if (!brandVpcIsContract) return <Remarks emphasize>輸入之商品品號與此廠商無合作關係</Remarks>;
    return "";
  }, [brandVpcIsContract]);

  const fetchNoInfo = useDebounce((value: string) => {
    if (value) {
      dispatch(fetchBrandVpc({ applicationId, no: value }));
    } else {
      dispatch(clearBrandVpc());
      form.setFieldsValue({ name: "" });
    }
  }, 1000);

  useEffect(() => {
    if (editRecord) {
      form.setFieldsValue({ ...editRecord, expiredDate: moment(editRecord.expiredDate) });
    }
  }, [editRecord, form]);

  useEffect(() => {
    form.setFieldsValue({ name: brandVpc?.name });
    if (!brandVpcIsContract) form.setFieldsValue({ name: "" });
  }, [brandVpc, brandVpcIsContract, form]);

  return (
    <Modal
      visible={!!open}
      confirmLoading={isFetching}
      onOk={() => form.submit()}
      onCancel={handleCancel}
      okText="確認"
      cancelText="取消"
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 12 }}
        onFinish={handleOnSubmit}
        onFinishFailed={() => message.error("必填欄位未填寫")}
      >
        <Form.Item label="商品品號" name="no" rules={[{ required: true, message: "" }]}>
          <Input onChange={(e) => fetchNoInfo(e.target.value)} disabled={cantEdit} />
        </Form.Item>
        <Form.Item label="商品名稱" name="name">
          <Input disabled />
        </Form.Item>
        <Form.Item label="申請進倉數量" name="requestQty" rules={[{ required: true, message: "" }]}>
          <InputNumber min={0} disabled={cantEdit} />
        </Form.Item>
        <Form.Item label="進價" name="purchasePrice" rules={[{ required: true, message: "" }]}>
          <InputNumber min={0} disabled={editRecord?.modifyStatus === ModifyStatus.NONE} />
        </Form.Item>
        <Form.Item label="倉別" name="storageType" rules={[{ required: true, message: "" }]}>
          <Select placeholder="請選擇" disabled={cantEdit}>
            {storageTypeOptions.map((option) => (
              <Select.Option key={option.name} value={option.value}>
                {option.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="批號" name="batch">
          <Input disabled={cantEdit} />
        </Form.Item>
        <Form.Item label="有效期限" name="expiredDate" rules={[{ required: true, message: "" }]}>
          <DatePicker disabled={cantEdit} />
        </Form.Item>
        {remark}
      </Form>
    </Modal>
  );
};
